import { useEffect, useState } from 'react'
import { colors } from '@fitpet/constants-global'
import { clsx } from 'clsx'
import { StyledDivider } from '@/components/common/divider'
import ListProductSliderV2 from '@/components/domains/list/list-product-slider-v2'
import { ListRecentlyProductSlider } from '@/components/domains/list/list-recently-product-slider'
import { useRecentlyProductList } from '@/components/domains/mypage/favorites/hooks/use-recently-product-list'
import { PageSizeEnum } from '@/constants/page-size.enum'
import { RequestStatusEnum } from '@/constants/request-status.enum'
import { useGetCartData } from '@/containers/hooks/cart/useGetCartData'
import useFrequentlyBoughtProductContainerHook from '@/containers/hooks/frequently-bought-product.container.hook'
import { UserContainer } from '@/containers/users/UserContainer'
import { GraphQLProductType } from '@/utils/product/product-card.util'
import styles from './cart-recommendation-section-v2.module.css'

export const CartRecommendationSectionV2 = () => {
  const { me } = UserContainer.useContainer()
  const [data, setData] = useState<GraphQLProductType[]>([])

  // 자주 구매한 상품 목록 조회
  const {
    data: frequentlyBoughtProducts,
    loading: isLoadingFrequentlyBoughtProducts,
    status: frequentlyBoughtProductsStatus,
    firstData: frequentlyBoughtProductFirstData,
  } = useFrequentlyBoughtProductContainerHook(PageSizeEnum.PageSize20)

  // 최근 본 상품 목록 조회
  const { recentlyProducts, isRecentlyProductsLoading } = useRecentlyProductList({
    length: PageSizeEnum.PageSize20,
  })

  const { getCartDataByChecked, updateCartDataParamsWithNewIds } = useGetCartData()

  const isFrequentlyBoughtProducts = frequentlyBoughtProducts.length > 0
  const isRecentlyProducts = !recentlyProducts || recentlyProducts.length > 0
  const isMultiplePurchasesFrequentlyBought = frequentlyBoughtProductFirstData?.boughtCount > 1

  const isShowFrequentlyBoughtProducts =
    frequentlyBoughtProductsStatus === RequestStatusEnum.Success &&
    isFrequentlyBoughtProducts &&
    isMultiplePurchasesFrequentlyBought

  // 자주 구매한상품이 없거나 자주 구매한 상품 중에 2개이상 구매한 상품이 없을때
  const isNoFrequentlyBoughtProductsOrSinglePurchase =
    !isFrequentlyBoughtProducts || (isFrequentlyBoughtProducts && !isMultiplePurchasesFrequentlyBought)

  // 최근 본 상품 보여주는 조건
  const isShowRecentlyProducts = isNoFrequentlyBoughtProductsOrSinglePurchase && isRecentlyProducts

  useEffect(() => {
    if (isShowFrequentlyBoughtProducts) {
      setData(frequentlyBoughtProducts.map(({ product, boughtCount }) => ({ ...product, boughtCount })))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frequentlyBoughtProductsStatus])

  return (
    <>
      <StyledDivider height="0.8rem" backgroundColor={colors.GRAY_70} />
      {isShowFrequentlyBoughtProducts && (
        <>
          <div className={styles.titleContainer}>
            <div className={clsx(styles.title, 'font-heading6-bold gray-900')}>
              {me?.name}
              님이
            </div>
            <div className={clsx(styles.title, 'font-heading6-bold gray-900')}>자주 산 상품이에요</div>
          </div>
          <ListProductSliderV2
            sectionName={`${me?.name} 님이 자주 산 상품이에요`}
            isLoading={isLoadingFrequentlyBoughtProducts}
            products={data}
            addToCartCallback={(ids) => {
              if (ids) {
                getCartDataByChecked({ param: updateCartDataParamsWithNewIds(ids) })
              }
            }}
          />
        </>
      )}
      {isShowRecentlyProducts && (
        <>
          <div className={styles.titleContainer}>
            <div className={clsx(styles.title, 'font-heading6-bold gray-900')}>최근 본 상품</div>
          </div>
          <ListRecentlyProductSlider
            sectionName="최근 본 상품"
            isLoading={isRecentlyProductsLoading}
            products={recentlyProducts}
            addToCartCallback={(ids) => {
              if (ids) {
                getCartDataByChecked({ param: updateCartDataParamsWithNewIds(ids) })
              }
            }}
          />
        </>
      )}
    </>
  )
}
